import { Navigate } from "react-router-dom";
import NotFound from "../pages/public/NotFound";
import { ROUTES } from "../constant/routes";

const otherRouter = [
  {
    path: ROUTES.NOT_FOUND,
    element: <NotFound />,
  },
  {
    path: "*",
    element: <Navigate to={ROUTES.NOT_FOUND} />,
  },
];

export default otherRouter;
